export const CARD_SUSPENDED = 'card_suspended';
export const CORE_LATE = 'core_late';
export const CORE_DELINQUENT = 'core_delinquent';
export const CARD_AWAITING_PAYMENT = 'card_awaiting_payment';
export const CORE_AWAITING_PAYMENT = 'core_awaiting_payment';
export const NONE_REQUIRED = 'none_required';
export const TURN_OFF = 'turn_off';
